import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaTwitter, FaGithub, FaEnvelope, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import { HiSparkles } from 'react-icons/hi';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-glow"></div>
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <Link to="/" className="footer-logo">
              <div className="logo-icon">C</div>
              <span className="logo-text">Cascade<span className="logo-accent">India</span></span>
            </Link>
            <p className="footer-description">
              Transforming businesses through innovative technology solutions. 
              We build digital experiences that drive growth and excellence.
            </p>
            <div className="footer-social">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <FaGithub />
              </a>
            </div>
          </div>

          <div className="footer-links-grid">
            <div className="footer-section">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-links">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/solutions">Solutions</Link></li>
                <li><Link to="/careers">Careers</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Services</h4>
              <ul className="footer-links">
                <li><Link to="/services">Software Development</Link></li>
                <li><Link to="/services">Cloud Solutions</Link></li>
                <li><Link to="/services">Data Analytics</Link></li>
                <li><Link to="/services">Cybersecurity</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Get in Touch</h4>
              <ul className="footer-contact">
                <li>
                  <FaEnvelope />
                  <span>info@cascadeindia.com</span>
                </li>
                <li>
                  <FaMapMarkerAlt />
                  <span>Mumbai, India</span>
                </li>
              </ul>
              <Link to="/contact" className="footer-cta">
                <HiSparkles />
                Start a Project
                <FaArrowRight />
              </Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Cascade India. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
